<template>
  <div class="loginPage">
		<div class="componentWrapper">
			<!-- <whatsNewHard
			></whatsNewHard> -->
			<whatsNew></whatsNew>
		</div>
  </div>
</template>

<script>

export default {
	name: 'WhatsNewPage',
	metaInfo: {
		title: 'What\'s New'
	}
}
</script>
<style>
.componentWrapper {
	margin: auto;
	width: 80%;
  margin-top: 130px;
}
</style>
